import { useState } from 'react';

/**
 * Copies something to paste where code can't go — an Outlook or Gmail signature: the
 * finished, clickable picture (as HTML on the clipboard), with plain text for anything
 * that only takes text. Pasting it gives the image with its link already set.
 */
export default function CopyRichButton({ html, text, label = 'Copy', primary = false }) {
  const [state, setState] = useState('');   // '' | 'done' | 'failed'
  // Older browsers, or when the clipboard API is refused: copy a rendered copy of it
  // (selecting real content keeps the picture and its link)
  const copyRendered = () => {
    const box = document.createElement('div');
    box.contentEditable = 'true';
    Object.assign(box.style, { position: 'fixed', left: '-9999px', top: '0' });
    box.innerHTML = html;
    document.body.appendChild(box);
    const range = document.createRange(); range.selectNodeContents(box);
    const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
    let ok = false;
    try { ok = document.execCommand('copy'); } catch { ok = false; }
    sel.removeAllRanges(); box.remove();
    return ok;
  };
  const copy = async () => {
    let ok = false;
    if (window.ClipboardItem && navigator.clipboard?.write) {
      try {
        await navigator.clipboard.write([new window.ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' }),
        })]);
        ok = true;
      } catch { ok = false; }
    }
    if (!ok) ok = copyRendered();
    setState(ok ? 'done' : 'failed');
    setTimeout(() => setState(''), 3000);
  };
  return (
    <button type="button" className={`btn btn-small ${primary ? 'btn-primary' : 'btn-secondary'}`} onClick={copy} aria-live="polite">
      {state === 'done' ? 'Copied — now paste it' : state === 'failed' ? 'Couldn’t copy: right-click the badge' : label}
    </button>
  );
}
